import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import AddAPhoto from '@material-ui/icons/AddAPhoto';
import HighlightOff from '@material-ui/icons/HighlightOff';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { IconButton } from '@material-ui/core';
import Avatar from 'react-avatar-edit';
import { Modal, Button, ButtonToolbar, ModalBody } from 'reactstrap';
import InfoIcon from '@material-ui/icons/Info';
import { upLoadFile64, fixBase64File } from '../../utils/smartutils';

const SmartAvatar = (props) => {
  const { avatarChangeHandler, avatarSrc, t, id } = props;
  const [preview, setPreview] = useState();
  const [modal, setModal] = useState(false);
  const [file, setFile] = useState();

  const onClose = () => {
    setPreview();
    setFile();
  };

  const onCrop = (newPreview) => {
    setPreview(newPreview);
  };

  const toggleModal = () => {
    setModal(!modal);
    setFile();
  };

  const onFileLoad = (upFile) => {
    setFile(upFile);
  };

  const onChangeImageClickHandler = () => {
    toggleModal();
  };

  const onRemoveImageClickHandler = () => {
    avatarChangeHandler({ fileId: '', fileUrl: '' });
  };

  const onConfirmClickHandler = async () => {
    if (preview) {
      const uploadedFile = await upLoadFile64(fixBase64File(preview));
      avatarChangeHandler(uploadedFile);
    } else {
      avatarChangeHandler({ fileId: '', fileUrl: '' });
    }
    toggleModal();
  };

  function addInfoContent() {
    if (file && !file.type.match(/image/)) {
      return (
        <div className="info-panel info info-panel-invalid-format">
          <div className="content">
            <InfoIcon font-size="small" />
            <span className="message">
              {t('notifications.invalid-image-format')}
            </span>
          </div>
        </div>
      );
    }

    if (
      (file && file.type === 'image/gif') ||
      (file && file.type === 'image/png') ||
      (file && file.type === 'image/webp')
    )
      return (
        <div className="info-panel info">
          <div className="content">
            <InfoIcon font-size="small" />
            <span className="message">
              {t('notifications.gif-png-webp-format')}
            </span>
          </div>
        </div>
      );

    return null;
  }

  return (
    <Fragment>
      <div className="frame-profile">
        {avatarSrc ? (
          <img src={avatarSrc} alt="Profile" className="avatar-img" />
        ) : (
          <AccountCircle
            style={{ width: 160, height: 160, color: '#646777' }}
          />
        )}
        <div className="form__form-group--centered">
          <IconButton
            onClick={onChangeImageClickHandler}
            style={{ height: 48 }}
          >
            <AddAPhoto />
          </IconButton>
          <IconButton
            onClick={onRemoveImageClickHandler}
            style={{ height: 48 }}
          >
            <HighlightOff />
          </IconButton>
        </div>
        {id ? <div className="id-profile">{id}</div> : null}
      </div>
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className="smart-avatar-modal"
        scrollable="true"
      >
        <ModalBody>
          <div className="smart-avatar">
            <Avatar
              width={390}
              height={295}
              imageHeight={295}
              onCrop={onCrop}
              onClose={onClose}
              onFileLoad={onFileLoad}
              closeIconColor="#000"
              label={t('general.click-to-select-photo')}
            />
          </div>
          {addInfoContent()}
        </ModalBody>

        <ButtonToolbar className="form__button-toolbar">
          <Button onClick={toggleModal}>{t('general.cancel')}</Button>
          <Button
            outline
            color="btn btn-success"
            onClick={onConfirmClickHandler}
          >
            {t('general.confirm')}
          </Button>
        </ButtonToolbar>
      </Modal>
    </Fragment>
  );
};

SmartAvatar.propTypes = {
  avatarChangeHandler: PropTypes.func.isRequired,
  avatarSrc: PropTypes.string,
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};

SmartAvatar.defaultProps = {
  avatarSrc: '',
  id: 0,
};

export default withTranslation('common')(SmartAvatar);
